/**
 * Lheading 플러그인
 * 하이픈 목록이 제목(heading)으로 오인식되는 것을 방지합니다.
 */

import type { Tokenizer, Tokens } from 'marked';
import type { MarkdownPlugin } from '../types';

export const lheadingPlugin: MarkdownPlugin = {
	name: 'lheading',
	tokenizer: {
		lheading(src: string) {
			// 첫 줄 텍스트, 두 번째 줄 하이픈 항목, 세 번째 줄 단독 하이픈 패턴을 매칭
			const cap = /^([^\n]+)\n[ ]*(-[ ]*[^\n]*)\n[ ]*(-[ ]*)(?:\n+|$)/.exec(src);
			if (cap) {
				// 세 번째 줄이 단독 하이픈('-')으로 시작하는 경우
				// 이는 일반적으로 목록이 의도된 것이지만, 마크다운 파서가
				// 이를 제목(heading)으로 잘못 해석할 수 있는 패턴입니다
				if (cap[cap.length - 1].startsWith('-')) {
					// 원래 텍스트를 유지하여 제목이 아닌 일반 텍스트로 처리
					let text = '';
					for (let i = 1; i < cap.length - 1; i++) {
						text += cap[i] + '\n';
					}
					text = text.trim();

					// 제목 토큰으로 반환하지만 실제로는 일반 텍스트처럼 렌더링되도록 함
					return {
						type: 'paragraph',
						raw: cap[0],
						depth: 2,
						text: text,
						tokens: this.lexer?.inline(text) || [],
					} as unknown as Tokens.Heading;
				}
			}

			return undefined;
		},
	} as Partial<Tokenizer>,
};
